import {
    AdyenPlatformExperience,
    all_locales,
    TransactionsOverview,
} from "@adyen/adyen-platform-experience-web";
import "@adyen/adyen-platform-experience-web/adyen-platform-experience-web.css";
import {
    Alert,
    Loading,
    StyleFunction,
    useAuth,
    useMerchantConfig,
    useThemedStyle,
} from "@venuepos/react-common";
import { useAdyenSessionsQuery } from "graphql-sdk";
import React, { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { View } from "react-native";
import { useAdminSession } from "../../session";
import { AdminContainer } from "../container";
import { ENV_HOSTNAME } from "../..";

export function AdyenTransactionsOverviewScreen() {
    const [t] = useTranslation();
    const merchantConfig = useMerchantConfig();
    const styles = useThemedStyle(styleFunc);
    const [{ locale }] = useAdminSession(["locale"]);
    const auth = useAuth();
    auth.enforce("merchant.report");

    const { loading, error, refetch } = useAdyenSessionsQuery({
        fetchPolicy: "no-cache",
    });

    const handleSessionCreate = useCallback(async () => {
        const result = await refetch();

        return result.data.adyenSessions;
    }, [refetch]);

    useEffect(() => {
        if (!loading && merchantConfig.adyenAccountHolderId) {
            AdyenPlatformExperience({
                environment:
                    ENV_HOSTNAME === "cloud.venuepos.net" ? "live" : "test",
                onSessionCreate: handleSessionCreate,
                availableTranslations: [all_locales],
                locale: locale === "en" ? "en-US" : "da-DK",
            }).then(core => {
                const transactionsOverview = new TransactionsOverview({ core });
                transactionsOverview.mount("#transactions-overview-container");
            });
        }
    }, [
        handleSessionCreate,
        loading,
        locale,
        merchantConfig.adyenAccountHolderId,
    ]);

    if (!merchantConfig.adyenAccountHolderId) {
        return (
            <Alert type="info">
                {t(
                    "backoffice.adyen_reports.adyen_not_setup",
                    "Adyen reports was not setup"
                )}
            </Alert>
        );
    }

    if (loading) {
        return (
            <AdminContainer>
                <Loading />
            </AdminContainer>
        );
    }

    if (error) {
        return (
            <Alert type="error">
                {t(
                    "backoffice.error.from_server",
                    "There was an error: {{errorText}}",
                    {
                        errorText: error.message,
                    }
                )}
            </Alert>
        );
    }

    return (
        <AdminContainer>
            <View
                id="transactions-overview-container"
                style={styles.reportComponent}
            />
        </AdminContainer>
    );
}

const styleFunc: StyleFunction = () => ({
    reportComponent: {
        paddingVertical: 5,
        zIndex: 100,
    },
});
